import React from 'react';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import CloseIcon from '../popup/closeIcon';
import { popupStore } from '../../store/popupStore';
import { iframeService } from '../../services/iframeService';

export function DepositPopup() {
  const t = useTranslation();
  return (
    <div className='cpt-min-win-popup-container darker'>
      <div className='cpt-game-msg-pop-info'>
        <CloseIcon handleClick={popupStore.close} />
        <div className='cpt-not-enough-content'>
          <p>{t(TranslationKeys.NotEnoughMoney)}.</p>
          <span>{t(TranslationKeys.SelectDifferentWallet)}</span>
          <div
            className='cpt-deposit-now'
            onClick={() => {
              iframeService.openDeposit();
              popupStore.close();
            }}
          >
            {t(TranslationKeys.DepositNow)}
          </div>
        </div>
      </div>
    </div>
  );
}
